module.exports = __webpack_public_path__ + "resources/img/img_cubrid_02_02_m_jp.e1d55804ed02debe19c92afb17673c65.png";